





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import ListDecorator from './ListDecorator.vue';
import Mixin from '../mixin';
import OrgInfo from '../class/OrgInfo';

@Component({
  components: { ListDecorator },
})
export default class OrganizationList extends Mixin {
  @Mutation private setOrganization!: (org: OrgInfo[]) => void;
  @Mutation private showOrg!: (id: string) => void;
  @Mutation private sortOrg!: (obj: any) => void;
  @Mutation private updateGroup!: (obj: OrgInfo[]) => void;
  @State private organization!: OrgInfo[];
  @State private user!: any;

  private sortProp: string = '';
  private sortAsc: boolean = false;

  private async mounted() {
    try {
      if (navigator.onLine) {
        this.getOrg();
      }
    } catch (ex) {
      this.msg(ex);
    }
  }

  private add(): void {
    this.$router.push('/organization/new');
  }

  private async del() {
    this.confirm('削除してもよろしいですか?', async () => {
      const list = Array.from(this.$el.querySelectorAll('td:first-of-type .mdl-checkbox.is-checked'))
        .map((v: any, i: any, self: any[]) => {
          const p = v.parentElement.parentElement as any;
          return {ID: p.id};
        });
      try {
        this.block();
        await API.del('api', '/organization/delete', {
          headers: { Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
          body: list,
        });
        this.msg('団体を削除しました');
        this.getOrg();
      } catch (ex) {
        this.msg(ex);
      } finally {
        this.uncheck();
        this.unblock();
      }
    });
  }

  private uncheck() {
    Array.from(this.$el.querySelectorAll('tr td:first-of-type .mdl-checkbox.is-checked'))
      .forEach((v: any, i: any, self: any[]) => {
        v.classList.remove('is-checked');
        (v.querySelector('input[type="checkbox"]') as HTMLInputElement).checked = false;
      });
  }

  private startRename(event: any, org: OrgInfo) {
    Array.from(this.$el.querySelectorAll('.btnCancel')).forEach((el) => {
      (el as HTMLInputElement).click();
    });
    let parentTd = (event!.target as Element).parentElement as HTMLElement;
    if (parentTd.tagName.toUpperCase() !== 'TD') {
      parentTd = parentTd.parentElement as HTMLElement;
    }
    const before = parentTd.innerHTML;
    const td = document.createElement('td');
    td.className = parentTd.className;

    const div = document.createElement('div');
    div.className = 'mdl-textfield mdl-js-textfield mdl-textfield--floating-label';
    div.addEventListener('click', (ev) => {
      ev.stopPropagation();
    });
    const update = async (ev: any) => {
      ev.stopPropagation();
      if (ev.keyCode === 27) {
        Array.from(this.$el.querySelectorAll('.btnCancel')).forEach((el) => {
          (el as HTMLInputElement).click();
        });
        return;
      }
      if (ev.keyCode && ev.keyCode !== 13) {
        return;
      }
      org.Name = input.value;
      try {
        ev.currentTarget.disabled = true;
        if (org.Name.length === 0) {
          this.msg('名前を入力してください');
          return;
        }
        this.updateGroup(await API.post('api', '/organization/update', {
          headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
          body: org,
        }));
        (parentTd.parentElement as Element).removeChild(td);
        parentTd.style.display = '';
        this.msg('名称を変更しました');
      } catch (ex) {
        if (ex.response && ex.response.status === 400) {
          this.msg('名前が長すぎます');
        } else {
          this.msg(ex);
        }
      } finally {
        ev.currentTarget.disabled = false;
      }
    };
    const input = document.createElement('input');
    input.className = 'mdl-textfield__input';
    input.id = 'tmpName';
    input.value = org.Name;
    input.addEventListener('keydown', update);
    const label = document.createElement('label');
    label.className = 'mdl-textfield__label';
    label.setAttribute('for', 'tmpName');
    label.innerHTML = '団体名';
    div.appendChild(input);
    div.appendChild(label);

    const btnAccept = this.createButton('done');
    btnAccept.addEventListener('click', update);
    const labelAccept = document.createElement('div');
    labelAccept.classList.add('mdl-tooltip');
    labelAccept.setAttribute('data-mdl-for', 'done');
    labelAccept.innerHTML = '確定';
    const btnCancel = this.createButton('clear');
    btnCancel.classList.add('mdl-button--accent');
    btnCancel.classList.add('btnCancel');
    btnCancel.addEventListener('click', (ev) => {
      ev.stopPropagation();
      (parentTd.parentElement as Element).removeChild(td);
      parentTd.style.display = '';
    });
    const labelCancel = document.createElement('div');
    labelCancel.classList.add('mdl-tooltip');
    labelCancel.setAttribute('data-mdl-for', 'clear');
    labelCancel.innerHTML = 'キャンセル';
    parentTd.style.display = 'none';
    td.appendChild(div);
    td.appendChild(btnAccept);
    td.appendChild(labelAccept);
    td.appendChild(btnCancel);
    td.appendChild(labelCancel);
    (parentTd.parentElement as Element).insertBefore(td, parentTd);
    input.focus();
  }

  private createButton(icon: string): Element {
    const btn = document.createElement('button');
    btn.className = 'mdl-button mdl-js-button mdl-button--icon';
    const i = document.createElement('i');
    i.id = icon;
    i.innerHTML = icon;
    i.className = 'material-icons';
    btn.appendChild(i);
    return btn;
  }

  private reload(p: (f: () => void) => void): void {
    p(async () => {
      await this.getOrg();
    });
    return;
  }

  private async getOrg() {
    try {
      const org = await API.post('api', '/organization', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      });
      await this.setOrganization(org);
    } catch (ex) {
      this.msg(ex);
    }
  }

  private showOrganization(id: string) {
    this.showOrg(id);
    this.$router.push('/group');
  }

  private sortOrganization(prop: string) {
    this.sortProp = prop;
    this.sortAsc = !this.sortAsc;
    this.sortOrg({prop, asc: this.sortAsc});
  }

}
